import { Link, useNavigate } from "react-router"

import { LoginForm } from "@repo/ui/components/auth-forms"

import { AuthLayout } from "@/components/auth-layout"
import { authClient } from "@/lib/auth-client"

export function LoginPage() {
  const navigate = useNavigate()

  return (
    <AuthLayout>
      <LoginForm
        forgotPasswordLink={<Link to="/forgot-password">Forgot password?</Link>}
        onPasswordSignIn={async (email, password) => {
          const { error } = await authClient.signIn.email({ email, password })

          if (error) {
            return error.message ?? "Invalid email or password"
          }

          await navigate("/", { replace: true })
          return null
        }}
        onMagicLink={async (email) => {
          const { error } = await authClient.signIn.magicLink({
            email,
            callbackURL: `${window.location.origin}/`,
          })

          return error ? (error.message ?? "Something went wrong") : null
        }}
      />
    </AuthLayout>
  )
}
